import { Stack } from "@mui/material";
import { ShimmerTitle } from "react-shimmer-effects";

const CommonShimmer = ({ rows = 6, height = 40, variant = "rectangular" }) => {
    return (
        <Stack spacing={1}>
            {Array.from(new Array(rows)).map((_, index) => (
                <ShimmerTitle key={index} line={4} gap={10} variant="primary" />
            ))}
        </Stack>
    );
};

export default CommonShimmer;
